import { httpV1 as http } from '../api';

export async function getAPPVersion(timestamp) {
  return http.get(`/backoffice/utils/deploy-version?app=admin&t=${timestamp}`);
}
